import { settingsPagePath } from '@/shared/constants'
import { epgPagePath } from '@/shared/constants/epgConstants'
import { homePagePath } from '@/shared/constants/homeConstants'
import { tvPagePath } from '@/shared/constants/tvConstants'
import { vodPagePath } from '@/shared/constants/vodConstants'
import { useAppStore, useTVStore, useVisibilityStore } from '@/shared/store'
import { seriesPagePath } from '@/shared/constants/seriesConstants'

const useVisibleContent = () => {
    const {
        setTvContentVisible,
        setEpgContentVisible,
        setHomeContentVisible,
        setSettingsContentVisible,
        setSeriesContentVisible,
        setVodContentVisible,
    } = useVisibilityStore((state) => ({
        setTvContentVisible: state.setTvContentVisible,
        setEpgContentVisible: state.setEpgContentVisible,
        setVodContentVisible: state.setVodContentVisible,
        setHomeContentVisible: state.setHomeContentVisible,
        setSettingsContentVisible: state.setSettingsContentVisible,
        setSeriesContentVisible: state.setSeriesContentVisible,
    }))

    const { isPIPMode } = useTVStore((state) => ({
        isPIPMode: state.isPIPMode,
    }))
    const { isUserLoggedIn } = useAppStore((state) => ({
        isUserLoggedIn: state.isUserLoggedIn,
    }))

    const setActualContentVisible = (actualPath: string) => {
        if (isUserLoggedIn) {
            switch (actualPath) {
                case homePagePath:
                    setHomeContentVisible()
                    break
                case tvPagePath:
                    setTvContentVisible(true)
                    break
                case epgPagePath:
                    setEpgContentVisible(isPIPMode)
                    break
                case seriesPagePath:
                    setSeriesContentVisible()
                    break
                case vodPagePath:
                    setVodContentVisible()
                    break
                case settingsPagePath:
                    setSettingsContentVisible()
                    break
            }
        }
    }
    return { setActualContentVisible }
}

export default useVisibleContent
